export default __webpack_public_path__ + "static/media/img-3.0d57eb54.png";